
import { defineComponent } from 'vue'

import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue'

import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'

import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper'
import TheFeedbackSectionCarouselSlide from './TheFeedbackSectionCarouselSlide.vue'
import { backend } from '@/main'
import { Review } from '@/backendTypes'

SwiperCore.use([Autoplay, Pagination, Navigation])

export default defineComponent({
  components: { Swiper, SwiperSlide, TheFeedbackSectionCarouselSlide },
  name: 'TheFeedbackSectionCarousel',
  data() {
    return {
      reviews: [
        {
          text: 'Спасибо за сотрудничество, работаем уже давно, никаких нареканий! Компания ощущается как ответственный партнер, всегда быстро закрывал бухгалтерские вопросы, и в целом, ощущение что пользуешься качественным сервисом. В итоге я стал экономить время, и больше зарабатывать.',
          client_name: 'Артем',
          client_type: 'агент',
        },
        {
          text: 'Благодарю сервис за индивидуальный подход, возникает чувство, что есть заинтересованность в каждом клиенте и в достойном предоставлении услуг, потому что хочется выделить, что руководитель компании держит  руку на пульсе, и вовлечен в процессы, которые происходят. Планирую продолжать сотрудничество!',
          client_name: 'Кристина',
          client_type: 'агент',
        },
        {
          text: 'Приветствую! Хочется поблагодарить компанию за качественный сервис, поддержка вызывает искреннее уважение, и находится на высоком уровне, во сколько бы я не обратилась, 24/7 чувствую доброжелательное и профессиональное отношение к моим вопросам. Желаю роста и развития данному сервису!',
          client_name: 'Василиса',
          client_type: 'агент',
        },
      ] as Review[],
    }
  },
  mounted() {
    ;(async () => {
      const directus = await backend
      if (!directus) {
        return
      }
      // const { data } = await directus.items('reviews').readMany();
      // if (data) {
      //   this.reviews = data as Review[];
      // }
    })()
  },
})
